/* eslint-disable no-shadow */
import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  other as state
} from '../store';

export default createReducer(state, {
  SET_VIEWED_EDUCATION_DATA: (state, { data }) => Immutable({
    ...state, viewedEducationData: data
  }),
  SET_NOTIFICATION_DATA: (state, { data }) => Immutable({ ...state, notificationData: data }),
});
